// extracted by mini-css-extract-plugin
export default {"titleContainer":"Title_titleContainer__m77zV","title":"Title_title__mrNq5","description":"Title_description__jtFuJ"};